export type TypeAnalyseSpeciale = 'nfs' | 'atb' | 'ecbu' | 'fichier' | 'fichier_valeur' | 'simple';

export interface ChampResultat {
  key: string;
  label: string;
  type: 'date' | 'text';
}

export const NFS_FIELDS: ChampResultat[] = [
  { key: 'date', label: 'Date', type: 'date' },
  { key: 'numero', label: 'Numéro', type: 'text' },
  { key: 'hb', label: 'Hb', type: 'text' },
  { key: 'hte', label: 'Hte', type: 'text' },
  { key: 'nr', label: 'NR', type: 'text' },
  { key: 'vgm', label: 'VGM', type: 'text' },
  { key: 'tcmh', label: 'TCMH', type: 'text' },
  { key: 'ccmh', label: 'CCMH', type: 'text' },
  { key: 'plaq', label: 'Plaq', type: 'text' },
  { key: 'nb', label: 'NB', type: 'text' },
  { key: 'pn', label: 'PN', type: 'text' },
  { key: 'pe', label: 'PE', type: 'text' },
  { key: 'pb', label: 'PB', type: 'text' },
  { key: 'l', label: 'L', type: 'text' },
  { key: 'm', label: 'M', type: 'text' },
];

export const ECBU_FIELDS: ChampResultat[] = [
  { key: 'date', label: 'Date', type: 'date' },
  { key: 'numero', label: 'Numéro', type: 'text' },
  { key: 'etat_frais', label: 'État frais', type: 'text' },
  { key: 'gram', label: 'GRAM', type: 'text' },
];

export const ATB_FIELDS: ChampResultat[] = [
  { key: 'date', label: 'Date', type: 'date' },
  { key: 'numero', label: 'Numéro', type: 'text' },
  { key: 'etat_frais', label: 'État frais', type: 'text' },
  { key: 'gram', label: 'GRAM', type: 'text' },
  { key: 'culture', label: 'Culture', type: 'text' },
  { key: 'germe', label: 'Germe', type: 'text' },
  { key: 'sensible', label: 'Sensible', type: 'text' },
  { key: 'intermediaire', label: 'Intermédiaire', type: 'text' },
  { key: 'resistants', label: 'Résistants', type: 'text' },
];

export function detecterTypeAnalyse(code: string): TypeAnalyseSpeciale {
  switch (code) {
    case 'NFS':
      return 'nfs';
    case 'ATB':
      return 'atb';
    case 'ECBU':
      return 'ecbu';
    case 'ELEC_HB':
    case 'ELEC_PROT':
      return 'fichier';
    case 'HBA1C':
      return 'fichier_valeur';
    default:
      return 'simple';
  }
}

export function champsPourType(type: TypeAnalyseSpeciale): ChampResultat[] {
  if (type === 'nfs') return NFS_FIELDS;
  if (type === 'atb') return ATB_FIELDS;
  if (type === 'ecbu') return ECBU_FIELDS;
  return [];
}

export function donneesRenseignees(donnees: Record<string, string> | null | undefined): boolean {
  if (!donnees) return false;
  return Object.values(donnees).some((v) => (v || '').trim() !== '');
}

function formatDateValeur(v: string): string {
  if (!v) return '';
  const iso = v.length === 10 ? `${v}T00:00:00` : v;
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return v;
  return d.toLocaleDateString('fr-FR');
}

export function formatDonneesResultat(
  type: TypeAnalyseSpeciale,
  donnees: Record<string, string> | null | undefined,
): { label: string; valeur: string }[] {
  if (!donnees) return [];
  const champs = champsPourType(type);
  return champs
    .filter((c) => (donnees[c.key] || '').trim() !== '')
    .map((c) => ({
      label: c.label,
      valeur: c.key === 'date' ? formatDateValeur(donnees[c.key]) : donnees[c.key],
    }));
}